import { PDFPrinterComponent } from '../../views/ts/components/PDFPrinterComponent';
(new PDFPrinterComponent()).init();
